import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDistanceToNow, format, parseISO } from 'date-fns';
import { getDateLocale } from 'utils/i18n';

export const MetadataUploadDate = ({ date }) => {
  const { t } = useTranslation();
  const dateObj = date ? parseISO(date) : null;
  const createdDate = dateObj && format(dateObj, t('formats:datetime'));
  const dateLocale = getDateLocale();

  return (
    <span
      data-e2e="video-list-upload-date"
      className="ct-video-additional-metadata__list-elem ct-video-additional-metadata__list-elem-ellipsis"
      data-tooltip-content={createdDate}
    >
      {dateObj && (
        <>
          <span className="ct-video-additional-metadata__list-elem-upload-date-distance">
            {formatDistanceToNow(dateObj, { addSuffix: true, locale: dateLocale })
              .replace('etwa ', '')
              .replace('about ', '')}
          </span>
          <span className="ct-video-additional-metadata__list-elem-upload-date">{createdDate}</span>
        </>
      )}
    </span>
  );
};
